export const InvoicesMyFiltersStorageKey = 'invoicesMyFilters';
export const CourierCallFiltersStorageKey = 'courierCallFilters';
export const InvoicesTemplateFiltersStorageKey = 'invoicesTemplateFilters';
